<template>
  <div>
    <BaseModalHeader>
      <BaseHeading :semantic-level="2" :display-level="1">
        Was geschieht hier?
      </BaseHeading>
    </BaseModalHeader>
    <BaseModalContent :class="$style.base">
      <BaseIllustration type="person">
        Sie benennen eine Kontaktperson, mit der wir den Termin vereinbaren, z.B. Ihre:n Mieter:in oder Betreuer:in.
      </BaseIllustration>
      <BaseIllustration type="calendar">
        Wir schicken dieser Person per E-Mail oder SMS die Termininformationen. Die Person kann uns über dieses Portal eine Rückmeldung zur Durchführbarkeit des Termins geben und ggf. einen anderen Termin anfordern.
      </BaseIllustration>
      <BaseIllustration type="app-confirm">
        Am vereinbarten Termin nehmen wir die geplanten Arbeiten im Objekt vor.
      </BaseIllustration>
    </BaseModalContent>
  </div>
</template>

<script setup lang="ts">
import BaseIllustration from '~/base/components/illustration/Illustration.vue'
import BaseModalHeader from '~/base/components/modal/ModalHeader.vue'
import BaseHeading from '~/base/components/heading/Heading.vue'
import BaseModalContent from '~/base/components/modal/ModalContent.vue'
</script>

<style module>
.base {
  text-align: center;
}
</style>
